module.exports = __webpack_public_path__ + "static/media/farm_pharm_11.82752ff4.jpg";